// utils/copyToClipboard.js
export async function copyToClipboard(text) {
  const value = String(text ?? "");

  // Modern API (works on HTTPS or localhost)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // fall through to legacy method
    }
  }

  // Legacy fallback (iOS Safari, HTTP, older browsers)
  try {
    const ta = document.createElement("textarea");
    ta.value = value;

    // Prevent keyboard + keep offscreen
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    ta.style.left = "-9999px";
    ta.style.opacity = "0";

    document.body.appendChild(ta);

    // iOS needs explicit selection range
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, ta.value.length);

    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
